export const gridCustomizationConstants = {
    SORT_GRID: 'SORT_GRID',
    FILTER_GRID: 'FILTER_GRID',
    FILTER_OPTIONS_GRID: 'FILTER_OPTIONS_GRID',
    TOGGLE_FILTER_ALL: 'TOGGLE_FILTER_ALL',
    CLEAR_ALL_GRID_FILTERS: 'CLEAR_ALL_GRID_FILTERS',
    SET_FILTER_OPTIONS: 'SET_FILTER_OPTIONS'
}
